import { faTrafficCone, faBan, faCalendarDay } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button } from "antd"
import { CheckCircleOutlined } from "@ant-design/icons"
import { VisitWorkareaStatuses } from "../../../common/constants"
import { Visit, VisitWorkareaStatusRecord } from "../scheduleApi"

type Props = {
  statusNumber: number
  visit: Visit | null
  workareaStatuses: VisitWorkareaStatusRecord[]
  effectiveWorkareaIds: number[]
}

const getStatusesToMatch = (statusNumber: number): number[] => {
  if (statusNumber === VisitWorkareaStatuses.Completed) {
    return [VisitWorkareaStatuses.Completed, VisitWorkareaStatuses.CompletedUnbillable]
  }
  return [statusNumber]
}

const getTagStyle = (statusNumber: number) => {
  switch (statusNumber) {
    case VisitWorkareaStatuses.InProgress:
      return {
        backgroundColor: '#fff7e6',
        borderColor: '#ffd591',
        color: '#fa8c16'
      }
    case VisitWorkareaStatuses.Completed:
      return {
        backgroundColor: '#f6ffed',
        borderColor: '#b7eb8f',
        color: '#52c41a'
      }
    case VisitWorkareaStatuses.Skipped:
    case VisitWorkareaStatuses.SkippedReschedule:
      return {
        backgroundColor: '#f5f5f5',
        borderColor: '#d9d9d9',
        color: '#000'
      }
    default:
      return {
        backgroundColor: '#f5f5f5',
        borderColor: '#d9d9d9',
        color: '#000'
      }
  }
}

const getIcon = (statusNumber: number) => {
  switch (statusNumber) {
    case VisitWorkareaStatuses.InProgress:
      return <FontAwesomeIcon icon={faTrafficCone} style={{ fontSize: '14px' }} />
    case VisitWorkareaStatuses.Completed:
      return <CheckCircleOutlined style={{ fontSize: '14px' }} />
    case VisitWorkareaStatuses.Skipped:
      return <FontAwesomeIcon icon={faBan} style={{ fontSize: '14px' }} />
    case VisitWorkareaStatuses.SkippedReschedule:
      return <FontAwesomeIcon icon={faCalendarDay} style={{ fontSize: '14px' }} />
    default:
      return null
  }
}

const WorkAreaStatusTag = ({ visit, workareaStatuses, statusNumber, effectiveWorkareaIds }: Props) => {
  const statusesToMatch = getStatusesToMatch(statusNumber)
  const count = workareaStatuses.filter(
    status => status.visitId === visit?.id &&
      effectiveWorkareaIds.includes(status.workareaId) &&
      statusesToMatch.includes(status.status)
  ).length

  if (count === 0) {
    return null
  }

  const tagStyle = getTagStyle(statusNumber)

  return <Button
    type="text"
    size="small"
    icon={
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        {getIcon(statusNumber)}
        <span>{count}</span>
      </div>
    }
    style={{
      backgroundColor: tagStyle.backgroundColor,
      borderColor: tagStyle.borderColor,
      borderRadius: '12px',
      padding: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '50px',
      height: '26px',
      color: tagStyle.color,
      fontSize: '14px',
      fontWeight: '500'
    }}
  />
}

export default WorkAreaStatusTag